import Vue from 'vue'

/*
	A one-line global event bus for app-wide UI signals that don't belong in
	the store — currently just `error` (a dismissable dialog any code can raise:
	bus.$emit('error', 'message')).
*/

export default new Vue()
